import { Signal } from "../../core/Signal.js";
import { IVideo } from "./IVideo.js";
import { VideoPlayerState } from "./VideoPlayerState.js";

export abstract class AbstractVideo implements IVideo {
    public onStateChange = Signal.create<[VideoPlayerState]>();
    public onTimeChange = Signal.create<[number]>();
    public onBufferChange = Signal.create<[number]>();
    public onDurationChange = Signal.create<[number]>();
    public onReady = Signal.create();

    public element: HTMLDivElement;
    public state: VideoPlayerState = VideoPlayerState.UNSTARTED;
    public time: number = 0;
    public duration: number = 0;
    public buffer: number = 0;
    public ready: boolean = false;

    constructor() {
        this.onStateChange.add((state) => {
            this.state = state;
        });
        this.onTimeChange.add((time) => {
            this.time = time;
        });
        this.onBufferChange.add((buffer) => {
            this.buffer = buffer;
        });
        this.onDurationChange.add((duration) => {
            this.duration = duration;
        });
        this.onReady.add(() => {
            this.ready = true;
        });
    }

    public abstract load(src: string): void;
    public abstract seek(time: number): void;
    public abstract play(): void;
    public abstract pause(): void;

    public dispose(): void {
        this.onStateChange.dispose();
        this.onTimeChange.dispose();
        this.onBufferChange.dispose();
        this.onDurationChange.dispose();
        this.onReady.dispose();

        this.onStateChange = null;
        this.onTimeChange = null;
        this.onBufferChange = null;
        this.onDurationChange = null;
        this.onReady = null;
    }
}